export const PLAN_TYPE = {
  BASIC: 'Basic',
  STANDARD: 'Standard',
  ADVANCED: 'Advanced',
  PREMIUM: 'Premium'
};
